import * as React from 'react';
import clsx from 'clsx';

import styles from './Modal.module.css';

type Props = {
  children: React.ReactNode;
  open: boolean;
  onClose?: () => void;
  maxWidth?: string;
};

export const Modal = ({ children, onClose, open, maxWidth }: Props): React.ReactElement => {
  return (
    <div className={clsx(styles['c-modal-calendar'], open && styles['open'])}>
      <div className={styles['c-modal-calendar__overlay']}></div>
      <div className={styles['c-modal-calendar__frame']} style={{ maxWidth }}>
        {onClose && (
          <div
            className={styles['c-modal-calendar__frame__close']}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onClose?.();
            }}
          />
        )}
        <div className={styles['c-modal-calendar__frame__body']}>{children}</div>
      </div>
    </div>
  );
};
